import PropTypes from 'prop-types';
import React, { Component } from 'react';

/**
 *  * This is a static react port of the cdc template us flag svg for the government notice
 */

export default class UsFlagLogo extends Component {

    render() {
        const { className } = this.props;
        return (
            <svg className={className} width="16" height="11" viewBox="0 0 64 44" fill="none" xmlns="http://www.w3.org/2000/svg" 
                xmlnsXlink="http://www.w3.org/1999/xlink">
                <g clipPath="url(#clip0_2_8)">
                    <path d="M64 0H0V44H64V0Z" fill="url(#pattern0_2_8)" />
                </g>
                <defs>
                    <pattern id="pattern0_2_8" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlinkHref="#image0_2_8" transform="scale(0.015625 0.0227273)" />
                    </pattern>
                    <clipPath id="clip0_2_8">
                        <rect width="64" height="44" fill="white" />
                    </clipPath>
                    <image id="image0_2_8" width="64" height="44" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAsCAIAAABaPSmoAAAAAXNSR0IArs4c6QAAAa9JREFUaAXtmEGOwjAMRXMR2t4B1i1XhuOQzdyEWYCSZ6mfpAORGsbIC8txEtvf+SkJh+MlyXC6ZjlehjVJzgc7auxY5+c8JbnN46rEeUxCh7iMSWinHtTGq9EPyNYTyGik8kcLUSp/XLIzy3+bx/4RYKvc8dtsR9+ruVj+Y2pQm222ewJ/A+W7EGDb5AvhdDV2S//FobhMSUgginnoQ10xkkHARCN62vhUJJOij8tkAhKXF32oewIVxV4Fpz0CaBV+VpATGBnt0h9r0r+FHnhYZUAoP4OQ/p4Ay/Ra/14E2PfU2Ta0sxVp5yFW3E+KpG5oVNCuRIBBUPcEnn++THXxz+sfIiAokm1DHqix8zxwbgvdfAtxg5pAlb8nwMoU9P4RULS41c6W41zJKmAeMtJW3b5K4EAzCBUc7dQ51xOQL0IPrPpHoHDIdz8cdh9hIUBPoFCg5sOhhnfNN/0b/P0Opaq5noB90X+Np6qisnM15dM/As1PWeMNnEYbF7i4fP8I1LzVWDbI7/2ca3TcFdae53LNGp13Ef0DN+CAoi0uxLlG9wRYyofOwnG0ewR+AUGV+u5vCeWaAAAAAElFTkSuQmCC" />
                </defs>
            </svg>

        );
    }

}

UsFlagLogo.propTypes = {
    className: PropTypes.string
}